module.exports = __webpack_public_path__ + "static/media/etax-logo.40c8a6b4.png";